import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomPaymentTypesApi } from '../api/clients/custom-payments/custom-payment-types.api';

const CustomPaymentTypeSelect = ({ value, onChange }) => {
  const { t } = useTranslation();
  const [paymentTypes, setPaymentTypes] = useState([]);

  useEffect(() => {
    const fetchPaymentTypes = async () => {
      try {
        const response = await CustomPaymentTypesApi.getCustomPaymentTypesForm();
        if (response.data) {
          setPaymentTypes(response.data);
        }
      } catch (error) {
        console.error('Failed to fetch custom payment types', error);
      }
    };

    fetchPaymentTypes();
  }, []);

  return (
    <div
      className='t-header-left'
      style={{ marginTop: 0, padding: 0, paddingLeft: '10px' }}>
      <div className='custom-search-box'>
        <div
          className='custom-select'
          style={{ marginTop: 0, paddingBottom: 0 }}>
          <select
            id='custom-payment-type'
            className='full-width-elem'
            value={value}
            onChange={onChange}
            style={{ height: '35px' }}>
            <option value=''>
              {t(
                'payments.filters.customPaymentTypePlaceholder',
                'Select Payment Type',
              )}
            </option>
            {paymentTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
        </div>
        <span className='search-icon'></span>
      </div>
    </div>
  );
};

export default CustomPaymentTypeSelect;
